import {
  MORAL_EDIT, MORAL_EDIT_FAILURE, MORAL_EDIT_SUCCESS, MORAL_UPDATE, MORAL_UPDATE_FAILURE, MORAL_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    moral: null,
    moralDetail: null,
    moralTarget: null
  },
  getters: {
    moralEdit: state => {
      return state.moral
    },
    moralEditDetail: state => {
      return state.moralDetail
    },
    moralEditTarget: state => {
      return state.moralTarget
    }
  },
  actions: {
    [MORAL_EDIT] ({dispatch, state, commit}, params = null) {
      var url = '/master/morals/' + params.id
      dispatch('apiGet', {url: url, data: params.id, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(MORAL_EDIT_FAILURE, res.data)
            } else {
              commit(MORAL_EDIT_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [MORAL_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/morals/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(MORAL_UPDATE_FAILURE, res.data)
            } else {
              commit(MORAL_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          params.errorCallback()
          throw error
        })
    }
  },
  mutations: {
    [MORAL_EDIT_FAILURE] (state, data) {
      console.log('MORAL_EDIT_FAILURE')
    },
    [MORAL_EDIT_SUCCESS] (state, data) {
      console.log('MORAL_EDIT_SUCCESS')

      state.moral = data.data.moral.data.attributes
      state.moralDetail = data.data.moral_detail.data
      state.moralTarget = data.data.moral_target.data
      if (data.callback) {
        data.callback()
      }
    },
    [MORAL_UPDATE_FAILURE] (state, data) {
      console.log('MORAL_UPDATE_FAILURE')
    },
    [MORAL_UPDATE_SUCCESS] (state, data) {
      console.log('MORAL_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/moral-edit.js